import './StatsColumn.scss';
import Component from './StatsColumn.js';
export default Component;
